import { get, includes, isEmpty } from 'lodash';

const HOME_FOLDER_ID = 0;

const getZapFolders = zap => get(zap, 'folder_ids', []);

const isZapFolderless = zap => isEmpty(getZapFolders(zap));

const isZapInFolder = (folderId, zap) => {
  return folderId === HOME_FOLDER_ID
    ? isZapFolderless(zap)
    : includes(getZapFolders(zap), folderId);
};

export default isZapInFolder;
